module.exports = __webpack_public_path__ + "static/img/yijianchaxun_all.a75c898.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serviceCenter/yijianchaxun_all.png
// module id = a9IP
// module chunks = 44